/* ==========================================================================
   eg-oregano-offer — Oil of Oregano PDP, hero offer behaviour

   Gallery, accordions, countdown and ship date are presentation. The offer is
   the part that matters: the chosen tier and the refill toggle drive every
   price in the block and the add-to-cart payload, the same way the Lymph offer
   (eg-lymphoria-combined) does.
   ========================================================================== */
(function () {
  'use strict';

  var SHIP_OFFSET_DAYS = 4;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function on(el, evt, fn) {
    if (el) el.addEventListener(evt, fn);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init(root) {
    if (!root || root.dataset.egoInit === 'true') return;
    root.dataset.egoInit = 'true';

    countdown(root);
    stockBar(root);
    shipDate(root);
    stickyBar(root);
    gallery(root);
    accordions(root);
    offer(root);
  }

  /* ----------------------------------------------------------- sticky bar */

  // in the moment the offer's add-to-cart button itself has scrolled off the
  // top (not the whole CTA block under it), out again as soon as it is back
  function stickyBar(root) {
    var bar = root.querySelector('[data-ego-sticky]');
    var anchor = root.querySelector('[data-ego-atc]');
    if (!bar || !anchor) return;

    bar.removeAttribute('hidden');

    // room under the footer, so the bar never sits on its last lines
    function reserve() {
      document.body.style.paddingBottom = bar.offsetHeight + 'px';
    }

    var ticking = false;
    function update() {
      ticking = false;
      bar.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom <= 0);
    }
    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () {
      reserve();
      request();
    });
    reserve();
    update();
  }

  /* ------------------------------------------------------------ countdown */

  // a 14-hour window kept per session, so a reload does not restart it
  function countdown(root) {
    var el = root.querySelector('[data-ego-countdown]');
    if (!el) return;

    var TOTAL = (13 * 3600 + 38 * 60 + 11) * 1000;
    var key = 'egoSaleEnd';
    var end = 0;
    try {
      end = parseInt(sessionStorage.getItem(key) || '0', 10);
    } catch (e) {
      /* storage blocked — the in-memory value is enough */
    }

    function reset() {
      end = Date.now() + TOTAL;
      try {
        sessionStorage.setItem(key, String(end));
      } catch (e) {
        /* noop */
      }
    }

    if (!end || end < Date.now()) reset();

    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (left <= 0) reset();
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------ stock bar */

  /* The bar runs once, when it first scrolls into view. Checked on the frame,
     not on a timer: a timer that resets on every scroll event would only fire
     once the scrolling stopped. */
  function stockBar(root) {
    var fill = root.querySelector('[data-ego-stock-fill]');
    if (!fill) return;

    var label = root.querySelector('[data-ego-stock-percent]');
    var frame = 0;

    function visible() {
      var box = fill.getBoundingClientRect();
      return box.top < window.innerHeight && box.bottom > 0;
    }

    function start() {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
      if (frame) cancelAnimationFrame(frame);
      fill.classList.add('is-filling');
      follow();
    }

    /* The figure beside the bar counts along with it. Rather than repeating the
       curve in script, the share is read back off the bar on every frame, so
       the number and the bar can never drift apart. */
    function follow() {
      if (!label) return;

      var track = fill.parentNode;
      var target = label.textContent;
      var running = true;

      // reduced motion leaves the bar unanimated: nothing to follow
      if (getComputedStyle(fill).animationName === 'none') return;

      function stop() {
        running = false;
        label.textContent = target;
      }

      fill.addEventListener('animationend', stop);
      // in case the animation never reports finishing
      setTimeout(stop, 2400);

      (function tick() {
        if (!running) return;
        var full = track.getBoundingClientRect().width;
        if (full) {
          var share = (fill.getBoundingClientRect().width / full) * 100;
          label.textContent = String(Math.round(share));
        }
        requestAnimationFrame(tick);
      })();
    }

    function check() {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        if (visible()) start();
      });
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    if (visible()) start();
  }

  /* ------------------------------------------------------------ ship date */

  function shipDate(root) {
    var el = root.querySelector('[data-ego-ship-date]');
    if (!el) return;

    var d = new Date();
    d.setDate(d.getDate() + SHIP_OFFSET_DAYS);

    var day = d.getDate();
    var suffix = 'th';
    if (day % 10 === 1 && day !== 11) suffix = 'st';
    else if (day % 10 === 2 && day !== 12) suffix = 'nd';
    else if (day % 10 === 3 && day !== 13) suffix = 'rd';

    el.textContent = MONTHS[d.getMonth()] + ' ' + day + suffix;
  }

  /* -------------------------------------------------------------- gallery */

  function gallery(root) {
    var track = root.querySelector('[data-ego-gallery-track]');
    var slides = track ? track.querySelectorAll('[data-ego-gallery-slide]') : [];
    var thumbs = root.querySelectorAll('[data-ego-thumb]');
    var strip = root.querySelector('[data-ego-thumbs]');
    if (!track || !slides.length || !thumbs.length) return;

    each(thumbs, function (thumb, i) {
      on(thumb, 'click', function () {
        if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      });
    });

    function sync() {
      var width = slides[0].getBoundingClientRect().width;
      var index = width > 0 ? Math.round(track.scrollLeft / width) : 0;
      index = Math.max(0, Math.min(index, thumbs.length - 1));

      each(thumbs, function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });

      // keep the active thumb inside the scrollable strip
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var t = thumbs[index];
        var left = t.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft || left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: left - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    }

    on(track, 'scroll', sync);
    window.addEventListener('resize', sync);
    sync();
  }

  /* ----------------------------------------------------------- accordions */

  // each panel opens and folds on its own; all start closed
  function accordions(root) {
    each(root.querySelectorAll('[data-ego-acc]'), function (item) {
      var toggle = item.querySelector('[data-ego-acc-toggle]');
      on(toggle, 'click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------------------------------------------------- offer / tiers / ATC */

  function offer(root) {
    var tiers = root.querySelectorAll('[data-ego-tier]');
    var subscribeBox = root.querySelector('[data-ego-subscribe]');
    var atcPrice = root.querySelector('[data-ego-atc-price]');
    var atcCompare = root.querySelector('[data-ego-atc-compare]');

    var state = {
      tier: root.querySelector('[data-ego-tier].is-selected') || tiers[0],
      subscribe: !!(subscribeBox && subscribeBox.checked)
    };

    /*
     * One toggle drives the whole block: with refills on, every tier shows its
     * selling-plan price and the subscription struck price; with it off, the
     * one-time product's price and its own struck price.
     */
    function render() {
      var tier = state.tier;
      if (!tier) return;
      var sub = state.subscribe;

      each(tiers, function (t) {
        var selected = t === tier;
        t.classList.toggle('is-selected', selected);
        t.setAttribute('aria-checked', String(selected));

        var price = t.querySelector('[data-ego-tier-price]');
        var compare = t.querySelector('[data-ego-tier-compare]');
        var save = t.querySelector('[data-ego-tier-save]');
        var saved = Number(sub ? t.dataset.saveSubCents : t.dataset.saveOnceCents) > 0;

        if (price) price.textContent = sub ? t.dataset.priceSub : t.dataset.priceOnce;
        if (compare) {
          compare.textContent = sub ? t.dataset.compareSub : t.dataset.compareOnce;
          // no saving in this state means no compare-at: nothing to strike through
          compare.hidden = !saved;
        }
        if (save) {
          save.textContent = 'You save ' + (sub ? t.dataset.saveSub : t.dataset.saveOnce);
          save.hidden = !saved;
        }
      });

      if (atcPrice) atcPrice.textContent = sub ? tier.dataset.priceSub : tier.dataset.priceOnce;
      if (atcCompare) {
        var saved = Number(sub ? tier.dataset.saveSubCents : tier.dataset.saveOnceCents) > 0;
        atcCompare.textContent = saved ? (sub ? tier.dataset.compareSub : tier.dataset.compareOnce) : '';
      }
    }

    each(tiers, function (tier) {
      on(tier, 'click', function () {
        state.tier = tier;
        render();
      });
    });

    on(subscribeBox, 'change', function () {
      state.subscribe = subscribeBox.checked;
      render();
    });

    render();
    addToCart(root, state);
  }

  function addToCart(root, state) {
    var button = root.querySelector('[data-ego-atc]');
    var error = root.querySelector('[data-ego-cart-error]');
    var addUrl = root.dataset.cartAddUrl || '/cart/add.js';
    var clearUrl = root.dataset.cartClearUrl || '/cart/clear.js';
    var cartUrl = root.dataset.cartUrl || '/cart.js';
    var checkoutUrl = root.dataset.checkoutUrl || '/checkout';
    var busy = false;

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
    }

    function setBusy(on) {
      busy = on;
      if (on) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    }

    /*
     * Shopify does not always answer with JSON: a bot check or an edge error
     * comes back as an HTML page, sometimes even with a 200. Parsing the body
     * ourselves keeps those from looking like a success.
     */
    function readJSON(res) {
      return res.text().then(function (text) {
        var data = null;
        try {
          data = JSON.parse(text);
        } catch (e) {
          /* not JSON — handled below */
        }
        if (!res.ok || !data) {
          var err = new Error((data && (data.description || data.message)) || '');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    }

    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body || {})
      }).then(readJSON);
    }

    // best effort: a blocked /cart.js must not stop a cart that did fill
    function cartCount() {
      return fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(readJSON)
        .then(function (cart) {
          return cart.item_count;
        })
        .catch(function () {
          return null;
        });
    }

    /*
     * One line: the chosen pack. The toggle picks the product as well as the
     * plan — a one-time purchase must never put the subscription variant in the
     * cart at its refill price.
     */
    function itemsFor(tier, subscribe) {
      if (!subscribe) {
        return [{ id: Number(tier.dataset.otpVariantId || tier.dataset.variantId), quantity: 1 }];
      }
      var item = { id: Number(tier.dataset.variantId), quantity: 1 };
      if (tier.dataset.sellingPlan) item.selling_plan = Number(tier.dataset.sellingPlan);
      return [item];
    }

    /*
     * The cart only ever holds this one offer, so it is cleared first — but a
     * failed clear must not block the purchase, it only risks a stale line.
     *
     * Checkout is reached only once the cart is known to hold something:
     * Shopify sends an empty cart from /checkout straight to the home page,
     * which is what a silently failed add used to look like.
     */
    on(button, 'click', function () {
      if (busy || !state.tier) return;

      var items = itemsFor(state.tier, state.subscribe);
      if (!items[0].id) {
        showError('This pack is unavailable right now. Please pick another one.');
        return;
      }

      showError('');
      setBusy(true);

      postJSON(clearUrl)
        .catch(function (err) {
          console.warn('[eg-oregano-offer] clear cart:', err);
        })
        .then(function () {
          return postJSON(addUrl, { items: items });
        })
        .then(cartCount)
        .then(function (count) {
          if (count === 0) throw new Error('');
          window.location.href = checkoutUrl;
        })
        .catch(function (err) {
          setBusy(false);
          showError(
            err.message ||
              'We could not add this to your cart. Please try again, or refresh the page.'
          );
          console.error('[eg-oregano-offer] add to cart:', err);
        });
    });
  }

  /* ----------------------------------------------------------------- boot */

  function boot() {
    each(document.querySelectorAll('[data-ego]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
